import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetTramitesUsuario } from '../shared/interfaces/tramite';
import {Page, QueryParam, Utils, PaginationParams, API_URL} from "lib-base";



@Injectable({
  providedIn: 'root'
})
export class TramRegistroService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/tram-registro`;
  }

  getTramitesUsuario( paginations:PaginationParams, radicado?: string | null ): Observable<Page<IGetTramitesUsuario>> {
    const url = `${this.baseUrl}/tramites-usuario`
    const params :QueryParam[] = [];
    if (paginations.page) {
      params.push({key:'page', value: paginations.page});
    }
    if (paginations.size) {
      params.push({key:'size', value: paginations.size});
    }
    if (paginations.sort) {
      params.push({key:'sort', value: paginations.sort});
    }
    if (radicado) {
      params.push({key:'radicado', value: radicado});
    }
    return this.http.get<Page<IGetTramitesUsuario>>(Utils.createQueryParams(url,params ));
  }

  getTramiteByRadicado(radicado: string): Observable<Required<IGetTramitesUsuario>> {
    return this.http.get<Required<IGetTramitesUsuario>>(`${this.baseUrl}/public/tramite-radicado/${radicado}`);
  }
}
